import React, { createContext, useContext, useState, useEffect } from "react";
import { round2, useAppContext } from "./AppContext";

const CardsContext = createContext();

let EMPTY_CARD = {
  numberofpayments: 1,
  paymentsInterest: 0,
  amount: 0,
  amountWithInterest: 0,
  paid: false,
};

export { EMPTY_CARD };

export const CardsProvider = ({ totalPrice, children }) => {
  const [cards, setCards] = useState([
    { ...EMPTY_CARD, amount: totalPrice, amountWithInterest: totalPrice },
  ]);
  const { interestTable } = useAppContext();

  useEffect(() => {
    setCards([
      { ...EMPTY_CARD, amount: totalPrice, amountWithInterest: totalPrice },
    ]);
  }, [totalPrice]);

  function _calculateInterest(numberOfPayments) {
    try {
      if (numberOfPayments >= 0 && numberOfPayments <= 12) {
        return interestTable[numberOfPayments] / 100;
      }
      console.error("Payment Error");
    } catch (e) {
      return 0;
    }
    return 0;
  }

  const calculatePaymentsInterest = (priceToPay, numberOfPayments) => {
    const interest = _calculateInterest(parseFloat(numberOfPayments));
    return (parseFloat(priceToPay) * interest * numberOfPayments) / 12;
    // סכום * ריבית / 12* מספר החודשים שהוא משלם
  };

  const allCardsInterest = (() => {
    let totalCardsFee = 0;
    cards.forEach((currentCard) => {
      totalCardsFee +=
        parseFloat(
          calculatePaymentsInterest(
            currentCard.amount,
            currentCard.numberofpayments
          )
        ) || 0;
    });
    return totalCardsFee;
  })();

  const setCardPaid = (cardIndex) => {
    let tempCards = JSON.parse(JSON.stringify(cards));
    tempCards[cardIndex].paid = true;
    setCards(tempCards);
  };

  const updateCards = (tmpCards) => {
    console.log("updateCards called with:", tmpCards);
    // Create a completely new array with new object references
    const newCards = tmpCards.map((card) => {
      const newCard = { ...card };
      newCard.amount = parseFloat(newCard.amount);
      newCard.paymentInterest = calculatePaymentsInterest(
        newCard.amount,
        newCard.numberofpayments
      );
      newCard.amountWithInterest = round2(
        newCard.amount + newCard.paymentInterest
      );
      return newCard;
    });
    console.log("updateCards setting new cards:", newCards);
    setCards(newCards);
  };

  return (
    <CardsContext.Provider
      value={{
        cards,
        updateCards,
        setCardPaid,
        allCardsInterest,
        interestTable,
      }}
    >
      {children}
    </CardsContext.Provider>
  );
};

export const useCards = () => {
  const context = useContext(CardsContext);
  if (context === undefined) {
    throw new Error("useCards must be used within a CardsProvider");
  }
  return context;
};

export default CardsContext;
